import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@aurumiq/ui/components/card";
import { CopyField } from "@aurumiq/ui/composite/copy-button";
import { env } from "@/lib/env";

/** How CI attaches artifacts: mirrors `scripts/publish-release.mjs` usage. */
export function CiHelpCard({ version, channel }: { version?: string; channel?: string }) {
  const cmd = `API_URL=${env.apiUrl} TOKEN=$AURUMIQ_RELEASE_TOKEN node scripts/publish-release.mjs ${version ?? "<version>"} ${channel ?? "<stable|beta>"} ./dist`;
  return (
    <Card>
      <CardHeader>
        <CardTitle>CI upload</CardTitle>
        <CardDescription>
          Artifacts are attached by the release workflow, not from this panel.
        </CardDescription>
      </CardHeader>
      <CardContent className="grid gap-3 text-sm">
        <ol className="list-decimal grid gap-1 pl-5 text-muted-foreground">
          <li>Creates (or reuses) the draft release for the version and channel.</li>
          <li>
            Requests presigned PUT URLs via{" "}
            <code className="font-mono text-xs">POST /admin/releases/&#123;id&#125;/artifacts</code>{" "}
            with filename, platform, arch, kind, size and SHA-512.
          </li>
          <li>Uploads every file in the directory, then publishes the release.</li>
        </ol>
        <CopyField value={cmd} label="Copy" />
        <p className="text-muted-foreground text-xs">
          <code className="font-mono">TOKEN</code> is an API key with the{" "}
          <code className="font-mono">releases:write</code> scope (Settings → API keys).
        </p>
      </CardContent>
    </Card>
  );
}
